<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5"></a>
<h1 class="toc1">Contents</h1>
<h2 class="toc2_"><a href="#/xhtml/005_About_the_author">Abbreviations</a></h2>
<h2 class="toc2_"><a href="#/xhtml/006_FM1">Author’s Note</a></h2>
<h2 class="toc2_"><a href="#/xhtml/007_Acknowledgements">Picture Acknowledgements</a></h2>
<h2 class="toc2_"><a href="#/xhtml/008_Dedication">Acknowledgements and Dedications</a></h2>
<h2 class="toc2_"><a href="#/xhtml/009_Introduction">Introduction</a></h2>
<h2 class="toc2"><a href="#/xhtml/010_Chapter_1"><span class="hang_">Chapter 1</span> The Natural Death</a></h2>
<h2 class="toc2"><span href="#/xhtml/011_Chapter_2" title="Link target outside of Sample"><span class="hang_">Chapter 2</span> The Soldierly Death</span></h2>
<h2 class="toc2"><span href="#/xhtml/012_Chapter_3" title="Link target outside of Sample"><span class="hang_">Chapter 3</span> The Criminal Death</span></h2>
<h2 class="toc2"><span href="#/xhtml/013_Chapter_4" title="Link target outside of Sample"><span class="hang_">Chapter 4</span> The Deathbed</span></h2>
<h2 class="toc2"><span href="#/xhtml/014_Chapter_5" title="Link target outside of Sample"><span class="hang_">Chapter 5</span> Of Corpses, Coffins, and Carriages</span></h2>
<h2 class="toc2"><span href="#/xhtml/015_Chapter_6" title="Link target outside of Sample"><span class="hang_">Chapter 6</span> The Common and the Noble Funeral</span></h2>
<h2 class="toc2"><span href="#/xhtml/016_Chapter_7" title="Link target outside of Sample"><span class="hang_">Chapter 7</span> Royal Funerals</span></h2>
<h2 class="toc2"><span href="#/xhtml/017_Chapter_8" title="Link target outside of Sample"><span class="hang_">Chapter 8</span> The Unorthodox Burial</span></h2>
<h2 class="toc2"><span href="#/xhtml/018_Chapter_9" title="Link target outside of Sample"><span class="hang_">Chapter 9</span> Remembrance</span></h2>
<h2 class="toc2"><span href="#/xhtml/019_BM1" title="Link target outside of Sample"><span class="hang_">Conclusion:</span> The Seventeenth Century and Beyond</span></h2>
<h2 class="toc2_"><span href="#/xhtml/020_Endnotes" title="Link target outside of Sample">Chapter Notes</span></h2>
<h2 class="toc2_"><span href="#/xhtml/021_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?32cf825d